export default "__VITE_ASSET__Dncqf5l$__"